module.exports = __webpack_public_path__ + "img/qilin-f-stage4-hungry.16ad732b.png";